module.exports = __webpack_public_path__ + "img/factor_b_blue.417b8d8b.svg";